import { $isElementNode, LexicalNode } from 'lexical';

export const collectNodes = (node: LexicalNode, list: LexicalNode[]) => {
  list.push(node);
  if ($isElementNode(node)) {
    node.getChildren().forEach((child) => collectNodes(child, list));
  }
};
